// extracted by mini-css-extract-plugin
export var drawerPaper = "_2n-0";
export var itemCard = "_2n-1";
export var itemImage = "_2n-2";